export enum YEAR_FORMAT {
  FULL = 'yyyy', // 2026
  TWO_DIGITS = 'yy' // 26
}

export enum MONTH_FORMAT {
  DIGIT = 'M', // 1-12
  TWO_DIGIT = 'MM', // 01-12
  ORDINAL = 'Mo', // 1st, 2nd, 3rd
  SHORT = 'MMM', // Jan, Feb, Mar
  LONG = 'MMMM' // January, February, March
}

export enum DAY_OF_MONTH_FORMAT {
  DIGIT = 'd', // 1-31
  TWO_DIGIT = 'dd', // 01-31
  ORDINAL = 'do' // 1st, 2nd, 3rd
}

export enum DAY_OF_WEEK_FORMAT {
  SHORT = 'E', // Mon,
  LONG = 'EEEE' // Monday,
}

export enum TIME_FORMAT {
  HOURS_MINUTES_AMPM = 'hh:mm a', // 02:30 pm
  HOURS_MINUTES_SECONDS_AMPM = 'hh:mm:ss a', // 02:30:20 pm
  HOURS_MINUTES_24 = 'HH:mm', // 14:30
  HOURS_MINUTES_SECONDS_24 = 'HH:mm:ss', // 14:30:20
  HOURS_MINUTES_SECONDS_24_FOR_FILE_NAMES = 'HHmmss' // 143020
}

export enum TIMEZONE_FORMAT {
  GMT = '(O)' // (GMT-8)
}
